import {Component, ContentChild, Input, TemplateRef} from "@angular/core";
import {ContentDirective} from "../../../shared/directives/content.directive";

@Component({
    selector: 'expanded-card',
    templateUrl: './expanded-card.component.html',
})
export class ExpandedCardComponent {

    @ContentChild(ContentDirective, { static: true, read: TemplateRef }) cardContentTpl: TemplateRef<any>;
    @Input() title = '';
    @Input() value = '';
    @Input() expandable = true;
    @Input() cardExpanded: boolean = false;
    @Input() margin = true;

    get filterContentTplContext(): object {
        return { $implicit: this.value };
    }



}